module.exports = __webpack_public_path__ + "static/media/empty-orders.1db5fed9.jpg";